<mat-form-field>
    <mat-label>{{title}}</mat-label>
    <mat-select [ngModel]="selection" (ngModelChange)="onSelectionChange($event)" [disabled]="visibleItems.length<2" multiple>
        <mat-select-trigger>{{selectionLabel}}</mat-select-trigger>
        <mat-option *ngIf="visibleItems.length>1" value="" (click)="onSelectAll()">{{allLabel}}</mat-option>
        <mat-divider *ngIf="visibleItems.length>1"></mat-divider>
        <mat-option *ngFor="let item of visibleItems" [value]="item.code">{{item.label}}</mat-option>
    </mat-select>
</mat-form-field>
